import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Save {{percentageAmount}}% on Selected Items',
    description:
      'Save {{percentageAmount}}% on your order when you order selected items. The offer is valid{{fromTo}} until the maximum limit for promotions is reached, whichever comes first. Cannot be combined with other promotions.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% Off from {{minSpendValue}}',
    description:
      'Save {{percentageAmount}}% on your order. The offer is valid{{fromTo}} until the maximum limit for promotions is reached, whichever comes first. Cannot be combined with other promotions.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Save {{amount}} on Selected Items',
    description:
      'Save {{amount}} when you order selected items. The offer is valid{{fromTo}} until the maximum limit for promotions is reached, whichever comes first. Cannot be combined with other promotions.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Save {{amount}} from {{minSpendValue}}',
    description:
      'Save {{amount}} with an order value. The offer is valid{{fromTo}} until the maximum limit for promotions is reached, whichever comes first. Cannot be combined with other promotions.',
  },
  [OfferKindEnum.Bogo]: {
    title: 'Buy 2 for the Price of 1!',
    description:
      'Buy one item and get second item for free. The offer is valid{{fromTo}} until the promotional limit is reached, whichever comes first. Cannot be combined with other promotions.',
    qualifying_items_description: 'Select the items the customer must order to get the free item.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: 'Buy one get one half price!',
    description:
      'Buy one item and get second item for half price. The offer is valid{{fromTo}} until the promotional limit is reached, whichever comes first. Cannot be combined with other promotions.',
    qualifying_items_description: 'Select the items the customer must order to get the free item.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Free item with an order value',
    description:
      'Receive a free item when you meet the offer conditions. The offer is valid{{fromTo}} until the promotional limit is reached, whichever comes first. Cannot be combined with other promotions.',
    reward_items_description: 'Select the free item (or items) that the customer can choose one from.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Free item with your order',
    description:
      'Receive a free item when you meet the offer conditions. The offer is valid{{fromTo}} until the promotional limit is reached, whichever comes first. Cannot be combined with other promotions.',
    qualifying_items_description: 'Select the items the customer must order to get the free item.',
    reward_items_description: 'Select the free item (or items) that the customer can choose one from.',
  },
};

export default {
  offers,
  from_to: ' from {{startsAt}} to {{endsAt}} or',
  qualifying_items_title: 'Qualifying Items',
  reward_items_title: 'Free Items',
  buttons: {
    add: 'Add To Cart',
  },
};
